<template>
  <div class="service-requests px-3">
    <div
      class="row no-gutters mb-2"
      v-if="serviceRequestsActive(value).length > 0"
    >
      <div class="col">
        <a class="py-2">
          <h4 class="mr-2 bigger svg">
            <span class="text-secondary">
              <PendingIcon></PendingIcon>
            </span>
            {{ $t("requestedServices") }}
          </h4>
        </a>
      </div>
    </div>
    <div class="mb-4 border-bottom">
      <template v-for="serviceRequest in serviceRequestsActive(value)">
        <item
          :caseId="value"
          :value="serviceRequest"
          :key="`service-request-active-${serviceRequest.id}`"
        ></item>
      </template>
      <div class="list">
        <div class="item item-last item-bottom">
          <a
            class="py-3 px-3 pointer text-primary"
            @click.prevent="show = !show"
          >
            <strong :class="{ closed: !show, open: show }">
              <small>
                <plus-icon v-if="!show"></plus-icon>
                <minus-icon v-else></minus-icon>
              </small>
              {{ $t("addServiceRequest") }}
            </strong>
          </a>
        </div>
      </div>
      <div class="list row no-gutters" v-show="show">
        <div class="item item-last col">
          <a>
            <input
              type="text"
              class="w-100 px-3 py-2"
              v-model="keyword"
              :placeholder="$t('searchService')"
            />
          </a>
        </div>
      </div>
      <div class="service-requests-list border-bottom" v-show="show">
        <div
          class="list row no-gutters"
          v-for="service of filteredServices"
          :key="`service-${service.id}`"
        >
          <div
            class="item item-last col pointer"
            @click.prevent="add(service.id)"
          >
            <a class="py-2 px-3" v-if="service">
              {{ service.name[authLocale] }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div
      class="row no-gutters mb-2"
      v-if="serviceRequestsFulfil(value).length > 0"
    >
      <div class="col">
        <a class="py-2">
          <h4 class="mr-2 bigger svg">
            <span class="text-success">
              <YesIcon></YesIcon>
            </span>
            {{ $t("fulfiledServicesRequests") }}
          </h4>
        </a>
      </div>
    </div>
    <template v-for="serviceRequest in serviceRequestsFulfil(value)">
      <item
        :caseId="value"
        :value="serviceRequest"
        :key="`service-request-fulfil-${serviceRequest.id}`"
      ></item>
    </template>
    <div
      class="row no-gutters mb-2"
      v-if="serviceRequestsFail(value).length > 0"
    >
      <div class="col">
        <a class="py-2">
          <h4 class="mr-2 bigger svg">
            <span class="text-danger">
              <NoIcon></NoIcon>
            </span>
            {{ $t("failedServicesRequests") }}
          </h4>
        </a>
      </div>
    </div>
    <template v-for="serviceRequest in serviceRequestsFail(value)">
      <item
        :caseId="value"
        :value="serviceRequest"
        :key="`service-request-fail-${serviceRequest.id}`"
      ></item>
    </template>
    <div
      class="row no-gutters mb-2"
      v-if="serviceRequestsCancel(value).length > 0"
    >
      <div class="col">
        <a class="py-2">
          <h4 class="mr-2 bigger svg">
            <span class="text-primary">
              <RemoveIcon></RemoveIcon>
            </span>
            {{ $t("canceledServicesRequests") }}
          </h4>
        </a>
      </div>
    </div>
    <template v-for="serviceRequest in serviceRequestsCancel(value)">
      <item
        :caseId="value"
        :value="serviceRequest"
        :key="`service-request-cancel-${serviceRequest.id}`"
      ></item>
    </template>
  </div>
</template>
<script>
import YesIcon from '@/components/Icons/Yes'
import NoIcon from '@/components/Icons/No'
import PlusIcon from '@/components/Icons/Plus'
import MinusIcon from '@/components/Icons/Minus'
import RemoveIcon from '@/components/Icons/Remove'
import PendingIcon from '@/components/Icons/Pending'
import Item from '@/components/ServiceRequestItem'
import { mapGetters, mapMutations } from 'vuex'
export default {
  components: {
    YesIcon,
    NoIcon,
    PlusIcon,
    MinusIcon,
    RemoveIcon,
    PendingIcon,
    Item
  },
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      keyword: null,
      show: false,
      searching: false
    }
  },
  computed: {
    ...mapGetters({
      authLocale: 'auth/locale',
      services: 'staticservice/services',
      serviceById: 'staticservice/byId',
      serviceRequests: 'pcase/serviceRequests',
      serviceRequestsIds: 'pcase/serviceRequestsIds',
      serviceRequestsActive: 'pcase/serviceRequestsActive',
      serviceRequestsFulfil: 'pcase/serviceRequestsFulfil',
      serviceRequestsFail: 'pcase/serviceRequestsFail',
      serviceRequestsCancel: 'pcase/serviceRequestsCancel'
    }),
    filteredServices () {
      const ret = []
      for (const s of this.services) {
        if (this.serviceRequestsIds(this.value).includes(s.id)) {
          continue
        }
        if (!this.keyword) {
          ret.push(s)
        } else if (s.name[this.authLocale].indexOf(this.keyword) !== -1) {
          ret.push(s)
        }
      }
      return ret
    }
  },
  methods: {
    ...mapMutations({
      setError: 'alert/setError',
      setServiceRequest: 'pcase/setServiceRequest'
    }),
    async add (service_id) {
      try {
        const params = {
          service_id: service_id
        }
        const response = await this.axios.post(
          `/api/patient-cases/${this.value}/service-requests`,
          params
        )
        this.setServiceRequest({
          id: this.value,
          serviceRequest: response.data.data
        })
      } catch (err) {
        this.setError(err)
      }
    }
  }
}
</script>
<style lang="scss">
.service-requests {
  .service-requests-list {
    max-height: 350px;
    overflow: auto;
  }
}
</style>
<i18n>
{
  "ka": {
    "addServiceRequest": "სერვისის მოთხოვნა",
    "searchService": "სერვისის ძიება",
    "requestedServices": "მოთხოვნილი სერვისები (ლოდინის რეჟიმში)",
    "fulfiledServicesRequests": "შესრულებული მოთხოვნილი სერვისები",
    "failedServicesRequests": "შეუსრულებული მოთხოვნილი სერვისები",
    "canceledServicesRequests": "გაუქმებული მოთხოვნილი სერვისები",
    "fulfiled": "შესრულდა",
    "failed": "არ შესრულდა",
    "canceled": "გაუქმება"
  },
  "en": {
    "addServiceRequest": "Request Service",
    "searchService": "Search",
    "requestedServices": "Requested Services (Pending)",
    "fulfiledServicesRequests": "Fulfiled Requested Services",
    "failedServicesRequests": "Failed Requested Services",
    "canceledServicesRequests": "Canceled Requested Services",
    "fulfiled": "Fulfiled",
    "failed": "Failed",
    "canceled": "Canceled"
  }
}
</i18n>
